// extracted by mini-css-extract-plugin
export default {"form":"SelectAddress_form__fRDU5","fields":"SelectAddress_fields__-cXtE","result":"SelectAddress_result__U6ZSU","title":"SelectAddress_title__eiodY"};